<section class="section-padding-home home-divider-light bg-white">
  <div class="container-max">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <span class="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-4">
        Our Track Record
      </span>
      <h2 class="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
        Building With Excellence
      </h2>
      <p class="text-xl text-slate-600 max-w-2xl mx-auto">
        Years of commitment to quality, innovation, and client satisfaction
      </p>
    </div>

    <!-- Stats Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
      <div 
        *ngFor="let stat of displayedStats"
        class="text-center p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-slate-100 hover:shadow-lg transition-all duration-300 group"
      >
        <div class="text-5xl lg:text-6xl font-bold text-transparent bg-gradient-to-r from-primary-600 to-accent-500 bg-clip-text mb-3">
          {{ stat.value }}{{ stat.suffix }}
        </div>
        <p class="text-lg text-slate-600 font-semibold">{{ stat.label }}</p>
      </div>
    </div>

    <!-- Trust Section -->
    <div class="mt-20 p-12 bg-gradient-to-r from-primary-50 to-accent-50 rounded-3xl border border-primary-200">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div class="space-y-4">
          <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-accent-500 rounded-xl flex items-center justify-center">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold text-slate-900">Quality Assurance</h3>
          <p class="text-slate-700">Rigorous quality checks at every stage of construction</p>
        </div>
        <div class="space-y-4">
          <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-accent-500 rounded-xl flex items-center justify-center">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold text-slate-900">On-Time Delivery</h3>
          <p class="text-slate-700">We respect deadlines and deliver projects on schedule</p>
        </div>
        <div class="space-y-4">
          <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-accent-500 rounded-xl flex items-center justify-center">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold text-slate-900">Cost Efficiency</h3>
          <p class="text-slate-700">Transparent pricing with no hidden costs</p>
        </div>
      </div>
    </div>
  </div>
</section>
